import { render, staticRenderFns } from "./UpdateLicenseBinding.vue?vue&type=template&id=71d97bab"
import script from "./UpdateLicenseBinding.vue?vue&type=script&lang=js"
export * from "./UpdateLicenseBinding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports